import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

export const BannerContainer = styled.div`
  border-radius: 4px;
  border-top: 1px solid ${select('blueBannerInfo')};
  border-right: 1px solid ${select('blueBannerInfo')};
  border-bottom: 1px solid ${select('blueBannerInfo')};
  border-left: 4px solid ${select('blueBannerInfo')};
  background: ${select('bannerInfoLightBlue')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  white-space: normal;
  max-width: ${({ device }) => {
    switch (device) {
      case 'mobile':
        return '328px';
      case 'tablet':
        return '546px';
      default:
        return '620px';
    }
  }};
  width: 100%;
  height: ${({ device }) => (device === 'mobile' ? '78px' : '48px')};
  margin: auto;
  margin-bottom: 24px;
  margin-top: ${({ device }) => (device === 'mobile' ? '82px' : '0')};
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-direction: ${({ device }) => (device === 'mobile' ? 'column' : 'row')};
  gap: ${({ device }) => {
    switch (device) {
      case 'mobile':
        return '12px';
      case 'tablet':
        return '0';
      default:
        return '0';
    }
  }};
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  width: ${({ device }) => (device === 'mobile' ? '100%' : 'auto')};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 8px;
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: ${select('black')};
`;

export const CTAButton = styled.button`
  color: ${select('black')};
  border: none;
  font-size: '14px';
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 130%;
  align-self: flex-end;
  height: 32px;
  margin-right: ${({ device }) => (device !== 'desktop' ? '0px' : '8px')};
  padding: 0px 12px;
  ${({ device }) => {
    return (
      device === 'desktop' &&
      css`
        :hover {
          border-radius: 8px;
          background: ${select('hoverCta')};
          gap: 0;
        }
      `
    );
  }}
`;
